import React from 'react';
import './landing-page.scss';
import ButtonComponent from '../../library/components/button.component';
import FooterComponent from '../common/components/footer.component';
import LoginIcon from '../../library/icons/login-icon';

const LandingPageComponent = () => {
    return (
        <div className="isp__landing-page-container">
            <div className="landing-page-container">
                <div className='logo-container'>
                    <img
                        className="login-jupiter"
                        src="/images/logo-login.svg"
                        alt="IntelliSpatial Portal"
                        width="550px"
                    />
                </div>

                <ButtonComponent
                    text="Log in"
                    icon={<LoginIcon />}
                    onClick={() => (window.location.href = `/account/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`)} />
            </div>
            <FooterComponent />
            <img
                className="brand-bg-left"
                src="/images/brand-bg-left.svg"
            />
            <img
                className="brand-bg-right"
                src="/images/brand-bg-right.svg"
            />
        </div>
    );
};

export default LandingPageComponent;
